import { getPathways } from 'api/pathways'
import { getUser } from 'api/users'
import PageTitle from 'components/page/PageTitle'
import LoadingPlaceholder from 'components/placeholders/LoadingPlaceholder'
import { useCallback, useState } from 'react'
import { useQuery } from 'react-query'
import { UserAdminDetailsForm } from '../UserAdminDetailsForm/UserAdminDetailsForm'
import { UserHistory } from '../UserHistory/UserHistory'

export function UserAdminDetails({ userId }: { userId: number }) {
  const [needUpdateHistory, setNeedUpdateHistory] = useState(false)
  const userQuery = useQuery(['user', userId], () => getUser({ id: userId }))
  const pathways = useQuery(['pathways'], () => getPathways())

  const handleAfterUpdate = useCallback(() => {
    userQuery.refetch()
  }, [userQuery])

  const handleResetNeedUpdateHistory = useCallback(() => {
    setNeedUpdateHistory(false)
  }, [])

  if (userQuery.isFetching || pathways.isLoading) {
    return <LoadingPlaceholder />
  }

  if (!userQuery.data || !pathways.data) {
    return <div>Something went wrong</div>
  }

  return (
    <>
      <PageTitle>Edit User View</PageTitle>

      <UserAdminDetailsForm user={userQuery.data.data} onAfterUpdate={handleAfterUpdate} />

      <UserHistory
        userId={userId}
        needUpdate={needUpdateHistory}
        resetNeedUpdate={handleResetNeedUpdateHistory}
      />
    </>
  )
}
